export const FIRST_ACCOUNT_SETUP_STARTER_PROMPT =
  "What is this project, and how should I start working on it?";

export const FIRST_ACCOUNT_SETUP_STARTER_PROMPT_STORAGE_KEY =
  "forge:first-account-setup-starter-prompt:v1";
